import React from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { FaFilePdf, FaFileExcel, FaPrint } from "react-icons/fa";
interface DataItem {
  [key: string]: any;
}
type Props = {
  ExportFunction: boolean;
 // data: any;
 data: DataItem[]; // Ensure data is typed as DataItem[]
  currentPage: number;
  itemsPerPage: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  pageSizeOptions?: number[];
  fileName?: string; 
};

const Pagination: React.FC<Props> = ({data,
  ExportFunction,
  currentPage,
  itemsPerPage,
  totalItems,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 25, 50,75,100], // Default options
  fileName = "Payment",
}) => {

  // Export data as PDF
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  
   // Function to process data and remove propertyAddress
   const processData = (inputData: DataItem[]): DataItem[] => {
    return inputData.map((item: DataItem) => {
      const { propertyAddress, ...rest } = item;
      return rest;
    });
  };

  const handleExportPDF = () => {
    const dataToExport = processData(data);
    const doc = new jsPDF({ orientation: 'landscape' }); // Landscape orientation
  
    const tableColumn = Object.keys(dataToExport[0]);
    const tableRows = dataToExport.map((item:any) => Object.values(item));
  
    autoTable(doc, {
      head: [tableColumn],
      body: dataToExport.map((item:any) => Object.values(item)),
      styles: {
        halign: 'center',  // Horizontal alignment
        valign: 'middle',  // Vertical alignment
        fontSize: 8,      // Smaller font size to fit more content
        cellPadding: 1,    // Reduced cell padding
      },
      columnStyles: {
        0: { cellWidth: 'auto' }, // Auto-size first column
        1: { cellWidth: 'auto' }, // Auto-size second column
        // You can repeat this for each column or set custom widths
      },
      headStyles: {
        fillColor: [22, 160, 133], // Header background color
        textColor: 255,            // Header text color
        fontStyle: 'bold',         // Header font style
        halign: 'center',          // Header alignment
      },
      bodyStyles: {
        halign: 'center', // Body alignment
      },
      margin: { top: 5, right: 5, bottom: 5, left: 15 }, // Margins
      pageBreak: 'auto', // Automatically add page breaks if content overflows
    });
  
   // doc.save("Payment_Report.pdf");
    doc.save(`${fileName}_Report.pdf`); // Updated
  };
  

  // Export data as Excel
  const handleExportExcel = () => {
    const dataToExport = processData(data);
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
   // XLSX.writeFile(workbook, "Payment_Report.xlsx");
   XLSX.writeFile(workbook, `${fileName}_Report.xlsx`); // Updated
  };

  // Print data
  const handlePrint = () => {
    const dataToExport = processData(data);
    const printWindow = window.open("", "_blank");
    const tableColumn = Object.keys(data[0]).join("</th><th>");
    const tableRows = dataToExport
      .map(
        (item: ArrayLike<unknown> | { [s: string]: unknown }) =>
          `<tr><td>${Object.values(item).join("</td><td>")}</td></tr>`
      )
      .join("");

    printWindow?.document.write(`
      <html>
        <head><title>Print Data</title></head>
        <body>
          <table border="1">
            <thead>
              <tr><th>${tableColumn}</th></tr>
            </thead>
            <tbody>${tableRows}</tbody>
          </table>
        </body>
      </html>
    `);
    printWindow?.document.close();
    printWindow?.print();
  };

  const handlePrevPage = () => {
    if (currentPage+1 > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage+1 < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onPageSizeChange(Number(e.target.value));
  };
 // console.log(currentPage)
  return (
<div className="flex  justify-between p-4  w-full lg:gap-7 overflow-x-auto">
      {/* Page size selection */}
      <div className="flex items-start space-x-2">
        <span className="text-gray-700 hidden md:inline">Items per page:</span>
        
        <select
          value={itemsPerPage}
          onChange={handlePageSizeChange}
          className="border border-gray-300 rounded-md py-1 px-2 text-gray-700 focus:outline-none"
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </div>

      {/* Export buttons */}
      {ExportFunction && (
        <div className="flex items-center space-x-2">
          <button
            title="Export PDF"
            onClick={handleExportPDF}
            className="flex items-center px-3 py-1 bg-gray-200 rounded-md hover:bg-red-50"
          >
            <FaFilePdf className="mr-1 text-red-600" />
            <span className="hidden md:inline">PDF</span>
          </button>
          <button
            title="Export Excel"
            onClick={handleExportExcel}
            className="flex items-center px-3 py-1 bg-gray-200 rounded-md hover:bg-green-50"
          >
            <FaFileExcel className="mr-1 text-green-600" />
            <span className="hidden md:inline">Excel</span>
          </button>
          <button
            title="Print"
            onClick={handlePrint}
            className="flex items-center px-3 py-1 bg-gray-200 rounded-md hover:bg-blue-50"
          >
            <FaPrint className="mr-1 text-blue-500" />
            <span className="hidden md:inline">Print</span>
          </button>
        </div>
      )}

      {/* Pagination controls */}
      <div className="flex items-center space-x-2">
      <span className="text-gray-700 hidden md:inline">
  {isNaN(totalItems) || totalItems === undefined ? (
    <span>Loading...</span> // Fallback for loading state
  ) : (
    <>
      {Math.min(((currentPage + 1) - 1) * itemsPerPage + 1, totalItems)}-
      {Math.min((currentPage + 1) * itemsPerPage, totalItems)} of {totalItems}
    </>
  )}
</span>

        <button
          onClick={() => onPageChange(1)}
          disabled={currentPage+1 === 1}
          className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300"
        >
          &lt;&lt;
        </button>
        <button
          onClick={handlePrevPage}
          disabled={currentPage+1 === 1}
          className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300"
        >
          &lt;
        </button>
        <span className="px-3 py-1 text-white bg-primary rounded-md">
          {currentPage+1}
        </span>
        <button
          onClick={handleNextPage}
          disabled={currentPage+1 === totalPages}
          className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300"
        >
          &gt;
        </button>
        <button
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage+1 === totalPages}
          className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300"
        >
          &gt;&gt;
        </button>
      </div>
    </div>
  );
};

export default Pagination;
